<template>
  <div id="ContentEditPanel">
    <div
      class="left"
      :class="'col-xs-' + 12/$store.getters.divider"
    >
      <div class="row mlr0 flex">
        <div
          v-for="(i, index) in content"
          :key="index"
          class="prl7 mb10"
          :class="type == 'alba' || type == 'blackjack' ? 'col-xs-6' : 'col-xs-4'"
        >
          <div class="p5 border relative">
            <el-input-number
              :min="0" :max="9"
              size="small"
              v-if="i.hasTextL1 && i.isNumber"
              :disabled="isBigIcon(i) || i.disabled"
              v-model="i.textL1"
              class="mb10"
              minlength="3"
            ></el-input-number>
            <el-input
              v-if="i.hasTextL1 && !i.isNumber"
              :disabled="isBigIcon(i) || i.disabled"
              v-model="i.textL1"
              class="mb10"
              minlength="3"
              :maxlength="(type=='aria' && layout == 'TT' && index < 2) ? maxLengthTT : maxLength"
            ></el-input>
            <el-input
              v-if="i.hasTextL2"
              :disabled="isBigIcon(i)"
              v-model="i.textL2"
              class="mb10"
              :maxlength="(type=='aria' && layout == 'TT' && index < 2) ? maxLengthTT : maxLength"
            ></el-input>
            <div class="sele-svg" v-if="!i.disabled">
              <IconInput v-if="i.hasIcon" v-model="i.icon" class="inline" :series="iconType(index, 'layout')" :popper-class="iconType(index, 'layout')" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="right" v-if="format != 'single'" :class="{['col-xs-' + 12/$store.getters.divider] : true,
    'bdr-d' : !$store.getters.isVertical, 'bdrt-d' : $store.getters.isVertical}">
      <div class="row mlr0 flex">
        <div
          class="prl7 mb10"
          :class="type == 'alba' ? 'col-xs-6' : 'col-xs-4'"
          v-for="(i, index) in rightContent"
          :key="index"
        >
          <div class="p5 border relative">
            <el-input-number
              :min="0" :max="9"
              size="small"
              v-if="i.hasTextL1 && i.isNumber"
              :disabled="isBigIcon(i) || i.disabled"
              v-model="i.textL1"
              class="mb10"
            ></el-input-number>
            <el-input
              v-if="i.hasTextL1 && !i.isNumber"
              :disabled="isBigIcon(i) || i.disabled"
              v-model="i.textL1"
              class="mb10"
              minlength="3"
              :maxlength="(type=='aria' && rightLayout == 'TT' && index < 2) ? rightMaxLengthTT : rightMaxLength"
            ></el-input>
            <el-input
              v-if="i.hasTextL2"
              :disabled="isBigIcon(i)"
              v-model="i.textL2"
              class="mb10"
              minlength="3"
              :maxlength="(type=='aria' && rightLayout == 'TT' && index < 2) ? rightMaxLengthTT : rightMaxLength"
            ></el-input>
            <div class="sele-svg" v-if="!i.disabled">
              <IconInput v-if="i.hasIcon" v-model="i.icon" class="inline" :series="iconType(index, 'rightLayout')" :popper-class="iconType(index, 'rightLayout')" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="{['col-xs-' + 12/$store.getters.divider] : true,
    'bdr-d' : !$store.getters.isVertical, 'bdrt-d' : $store.getters.isVertical}" v-if="$store.getters.isTriple">
      <div class="row mlr0 flex">
        <div
          class="prl7 mb10"
          :class="type == 'alba' ? 'col-xs-6' : 'col-xs-4'"
          v-for="(i, index) in tripleRightContent"
          :key="index"
        >
          <div class="p5 border relative">
            <el-input-number
              :min="0" :max="9"
              size="small"
              v-if="i.hasTextL1 && i.isNumber"
              :disabled="isBigIcon(i) || i.disabled"
              v-model="i.textL1"
              class="mb10"
            ></el-input-number>
            <el-input
              v-if="i.hasTextL1 && !i.isNumber"
              :disabled="isBigIcon(i) || i.disabled"
              v-model="i.textL1"
              class="mb10"
              minlength="3"
              :maxlength="(type=='aria' && tripleRightLayout == 'TT' && index < 2) ? tripleRightMaxLengthTT : tripleRightMaxLength"
            ></el-input>
            <el-input
              v-if="i.hasTextL2"
              :disabled="isBigIcon(i)"
              v-model="i.textL2"
              class="mb10"
              minlength="3"
              :maxlength="(type=='aria' && tripleRightLayout == 'TT' && index < 2) ? tripleRightMaxLengthTT : tripleRightMaxLength"
            ></el-input>
            <div class="sele-svg" v-if="!i.disabled">
              <IconInput v-if="i.hasIcon" v-model="i.icon" class="inline" :series="iconType(index, 'tripleRightLayout')" :popper-class="iconType(index, 'tripleRightLayout')" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import IconInput from "../../../components/IconInput.vue";
import isBigIconMixin from '../../../mixins/isBigIconMixin';

export default {
  name: "ContentEditPanel",
  components: {
    IconInput
  },
  mixins: [
    isBigIconMixin
  ],
  data() {
    return {
      type: null,
      layout: null,
      rightLayout: null,
      tripleRightLayout: null,
      content: null,
      rightContent: null,
      tripleRightContent: null,
      format: null,
      contentEditBoxType: {
        iconOnly: { iconEditBox: true },
        singleLineText: { textEditBoxL1: true },
        doubleLineText: { textEditBoxL1: true, textEditBoxL2: true },
        iconSingleLineTextMid: { textEditBoxL1: true, iconEditBox: true },
        iconDoubleLineTextMid: {
          textEditBoxL1: true,
          textEditBoxL2: true,
          iconEditBox: true,
        },
        iconSingleLineText: { textEditBoxL1: true, iconEditBox: true },
        iconDoubleLineText: {
          textEditBoxL1: true,
          textEditBoxL2: true,
          iconEditBox: true,
        },
      },
      fontSizeLength: {
        ariatt: { //only for first two buttons
          2.5: 8,
          3.5: 6,
          4.5: 4,
        },
        aria: {
          2.5: 10,
          3.5: 8,
          4.5: 5, //6,
        },
        alba: {
          2.5: 16,
          3.5: 13,
          4.5: 10,
        },
        axes: {
          2.5: 10,
          3.5: 8,
          4.5: 5, //6,
        },
      }
    };
  },
  mounted() {
    //read from store
    this.type = this.$store.state.artwork.type;
    this.format = this.$store.state.artwork.format;
    this.content = this.$store.state.artwork.content;
    this.rightContent = this.$store.state.artwork.rightContent;
    this.tripleRightContent = this.$store.state.artwork.tripleRightContent;
    this.layout = this.$store.state.artwork.layout;
    this.rightLayout = this.$store.state.artwork.rightLayout;
    this.tripleRightLayout = this.$store.state.artwork.tripleRightLayout;
  },
  computed: {
    maxLength() {
      if (this.type == null || typeof this.$store.state.artwork.fontSize == 'undefined') return 0;
      return this.fontSizeLength[this.type][this.$store.state.artwork.fontSize];
    },
    maxLengthTT() {
      if (this.type == null) return 0;
      return this.fontSizeLength.ariatt[this.$store.state.artwork.fontSize];
    },
    rightMaxLength() {
      if (this.type == null || typeof this.$store.state.artwork.rightFontSize == 'undefined') return 0;
      return this.fontSizeLength[this.type][
        this.$store.state.artwork.rightFontSize
      ];
    },
    rightMaxLengthTT() {
      if (this.type == null) return 0;
      return this.fontSizeLength.ariatt[
        this.$store.state.artwork.rightFontSize
      ];
    },
    tripleRightMaxLength() {
      if (this.type == null || typeof this.$store.state.artwork.tripleRightFontSize == 'undefined') return 0;
      return this.fontSizeLength[this.type][
        this.$store.state.artwork.tripleRightFontSize
      ];
    },
    tripleRightMaxLengthTT() {
      if (this.type == null) return 0;
      return this.fontSizeLength.ariatt[
        this.$store.state.artwork.tripleRightFontSize
      ];
    },
  },
  watch: {
    content: {
      deep: true,
      handler(val) {
        val = val.map((i) => {
          if (this.isBigIcon(i)) {
            i.textL1 = "";
            i.textL2 = "";
          }
          return i;
        });

        this.$store.state.artwork.content = val;
      },
    },
    rightContent: {
      deep: true,
      handler(val) {
        if (val) {
          val = val.map((i) => {
            if (this.isBigIcon(i)) {
              i.textL1 = "";
              i.textL2 = "";
            }
            return i;
          });

          this.$store.state.artwork.rightContent = val;
        }
      },
    },
    tripleRightContent: {
      deep: true,
      handler(val) {
        if (val) {
          val = val.map((i) => {
            if (this.isBigIcon(i)) {
              i.textL1 = "";
              i.textL2 = "";
            }
            return i;
          });

          this.$store.state.artwork.tripleRightContent = val;
        }
        
      },
    },
    maxLength(newVal, oldVal) {
      if (newVal < oldVal) {
        this.content = this.content.map((c, index) => {
          if (typeof c.textL1 != "undefined" && !c.isNumber) {
            if (this.type == 'aria' && this.layout == 'TT' && index < 2) {
              c.textL1 = c.textL1.substr(0, this.maxLengthTT);
            } else {
              c.textL1 = c.textL1.substr(0, newVal);
            }
          }
          if (typeof c.textL2 != "undefined") {
            if (this.type == 'aria' && this.layout == 'TT' && index < 2) {
              c.textL2 = c.textL2.substr(0, this.maxLengthTT);
            } else {
              c.textL2 = c.textL2.substr(0, newVal);
            }
          }
          return c;
        });
      }
    },
    rightMaxLength(newVal, oldVal) {
      if (newVal < oldVal) {
        this.rightContent = this.rightContent.map((c, index) => {
          if (typeof c.textL1 != "undefined" && !c.isNumber) {
            if (this.type == 'aria' && this.rightLayout == 'TT' && index < 2) {
              c.textL1 = c.textL1.substr(0, this.rightMaxLengthTT);
            } else {
              c.textL1 = c.textL1.substr(0, newVal);
            }
          }
          if (typeof c.textL2 != "undefined") {
            if (this.type == 'aria' && this.rightLayout == 'TT' && index < 2) {
              c.textL2 = c.textL2.substr(0, this.rightMaxLengthTT);
            } else {
              c.textL2 = c.textL2.substr(0, newVal);
            }
          }
          return c;
        });
      }
    },
    tripleRightMaxLength(newVal, oldVal) {
      if (newVal < oldVal) {
        this.tripleRightContent = this.tripleRightContent.map((c, index) => {
          if (typeof c.textL1 != "undefined" && !c.isNumber) {
            if (this.type == 'aria' && this.tripleRightLayout == 'TT' && index < 2) {
              c.textL1 = c.textL1.substr(0, this.tripleRightMaxLengthTT);
            } else {
              c.textL1 = c.textL1.substr(0, newVal);
            }
          }
          if (typeof c.textL2 != "undefined") {
            if (this.type == 'aria' && this.tripleRightLayout == 'TT' && index < 2) {
              c.textL2 = c.textL2.substr(0, this.tripleRightMaxLengthTT);
            } else {
              c.textL2 = c.textL2.substr(0, newVal);
            }
          }
          return c;
        });
      }
    },
  },
  methods: {
    iconType(id, layout) {
      if (this.type == "alba") {
        if ((this.$store.state.artwork[layout] == "K8" || this.$store.state.artwork[layout] == "K4") && id > 1 && id < 6) {
          return "albaNoDouble";
        }
        if (this.$store.state.artwork[layout] == "M1" && id < 2) {
          return "albaNoDouble";
        }
      }
      if (this.type == "aria" && this.$store.state.artwork[layout] == "L12") {
        return "aria|L12";
      }
      
      return this.type;
    },
  },
};
</script>
